module.exports = __webpack_public_path__ + "img/cup.3fa934b3.svg";